import {
  ArrowLeft,
  ArrowRight,
  ChevronFirst,
  ChevronLast,
  MoreHorizontal,
  Circle,
  Dot,
} from "lucide-react";

const Pagination = ({ currentPage, hasMore, onPrevious, onNext }) => {
  return (
    <div className="flex items-center justify-center gap-4 mt-6">
      {/* Previous button */}
      <button
        onClick={onPrevious}
        disabled={currentPage <= 1}
        className={`flex items-center gap-2 px-4 py-2 rounded-lg border transition-all duration-200 ${
          currentPage <= 1
            ? "text-gray-400 cursor-not-allowed border-gray-200 bg-gray-50"
            : "text-[#4f22d8] border-[#4f22d8] hover:bg-[#4f22d8] hover:text-white"
        }`}
      >
        <ArrowLeft className="w-4 h-4" />
        <span className="text-sm font-medium">Previous</span>
      </button>

      {/* Page indicator with decorative elements */}
      <div className="flex items-center gap-3 px-6 py-2 bg-gradient-to-r from-[#4f22d8]/10 to-[#4f22d8]/5 rounded-lg border border-[#4f22d8]/20">
        <Circle className="w-3 h-3 text-[#4f22d8]" fill="currentColor" />
        <span className="text-sm font-semibold text-[#4f22d8]">
          Page {currentPage}
        </span>
        <Dot className="w-4 h-4 text-[#4f22d8]" />
      </div>

      {/* Next button */}
      <button
        onClick={onNext}
        disabled={!hasMore}
        className={`flex items-center gap-2 px-4 py-2 rounded-lg border transition-all duration-200 ${
          !hasMore
            ? "text-gray-400 cursor-not-allowed border-gray-200 bg-gray-50"
            : "text-[#4f22d8] border-[#4f22d8] hover:bg-[#4f22d8] hover:text-white"
        }`}
      >
        <span className="text-sm font-medium">Next</span>
        <ArrowRight className="w-4 h-4" />
      </button>
    </div>
  );
};

export default Pagination;
